import React, {useEffect, useState} from 'react';
import {SearchProvider} from '../../../contexts/SearchContext';
import withLayout from '../../../hoc/withLayout';
import PageMeta from '../../../components/PageMeta';
import {Modal} from '@redq/reuse-modal';
import {useRouter} from 'next/router';
import SearchPage from '../../../containers/Search';
import {useTranslation} from 'next-i18next';
import simplePage from "../../../serverProps/simplePage";

import LogoIcon from '@core/ui/static/images/icon.png?resize&sizes[]=200';

import Car from '@core/ui/static/images/categories/img-voitures@2x.jpg?resize&sizes[]=200';
import Dress from '@core/ui/static/images/categories/img-vetements@2x.jpg?resize&sizes[]=200';
import Immo from '@core/ui/static/images/categories/img-immobilier@2x.jpg?resize&sizes[]=200';
import Mobilier from '@core/ui/static/images/categories/img-mobilier@2x.jpg?resize&sizes[]=200';
import Phone from '@core/ui/static/images/categories/img-telephonie@2x.jpg?resize&sizes[]=200';
import Kite from '@core/ui/static/images/categories/img-sports@2x.jpg?resize&sizes[]=200';
import Computer from '@core/ui/static/images/categories/img-informatique@2x.jpg?resize&sizes[]=200';

const Search = props => {
  const router = useRouter();
  const {i18n, t} = useTranslation();

  const {query} = router;
  let {category, town} = query;

  if (category === 'all') {
    category = null;
  }

  const getInterpolation = () => {
    const i18nInterpolation = {};

    if (!(i18n.exists instanceof Function)) return i18nInterpolation;

    if (town) {
      const townUtf8 = decodeURIComponent(town);
      i18nInterpolation.town = `, ${townUtf8}`;
    }

    if (category) {
      if (i18n.exists(`category.slug.${category}`)) {
        i18nInterpolation.category = `, ${t(`category.slug.${category}`)}`;
      } else {
        // redirect because category doesn't exist
        if (typeof window !== 'undefined') {
          router.replace('/annonces/all');
        }
      }
    }

    return i18nInterpolation;
  };

  const getTitle = () => {
    let pageTitle = '';

    if (!(i18n.exists instanceof Function)) return pageTitle;

    const i18nInterpolation = getInterpolation();

    if (
      i18n.exists(
        `${process.env.APP_LOCALIZATION}:search.head.category.title.${category}`
      )
    ) {
      pageTitle = t(
        `${process.env.APP_LOCALIZATION}:search.head.category.title.${category}`,
        i18nInterpolation
      );
    } else {
      pageTitle = t(
        `${process.env.APP_LOCALIZATION}:search.head.defaultTitle`,
        i18nInterpolation
      );
    }

    return pageTitle;
  };

  const getDescription = () => {
    let pageDescription = '';

    if (!(i18n.exists instanceof Function)) return pageDescription;

    const i18nInterpolation = getInterpolation();

    if (
      i18n.exists(
        `${process.env.APP_LOCALIZATION}:search.head.category.description.${category}`
      )
    ) {
      pageDescription = t(
        `${process.env.APP_LOCALIZATION}:search.head.category.description.${category}`
      );
    } else {
      pageDescription = t(
        `${process.env.APP_LOCALIZATION}:search.head.description`,
        i18nInterpolation
      );
    }

    return pageDescription;
  };

  const getImage = () => {
    let image = '';

    switch (category) {
      case 'voitures':
        image = Car.src;
        break;
      case 'ventes-immobilieres':
        image = Immo.src;
        break;
      case 'mobilier':
        image = Mobilier.src;
        break;
      case 'informatique':
        image = Computer.src;
        break;
      case 'telephonie':
        image = Phone.src;
        break;
      case 'vetements':
        image = Dress.src;
        break;
      case 'sports':
        image = Kite.src;
        break;
      default:
        image = LogoIcon.src;
        break;
    }

    return image;
  };

  const [infos, setInfos] = useState({description: getDescription(), image: getImage(), title: getTitle()});
  const {description, image, title} = infos;

  useEffect(() => {
    setInfos({description: getDescription(), image: getImage(), title: getTitle()});
  }, [query]);

  return (
    <>
      <PageMeta title={title} description={description} image={image}/>
      <SearchProvider>
        <SearchPage/>
      </SearchProvider>
      <Modal/>
    </>
  );
};

export default withLayout(Search, true);

export const getServerSideProps = simplePage;
